export default function ExcitedStateVisual() {
  return <div>excited state works</div>;
}